module.exports = __webpack_public_path__ + "img/lock-open.a0d139c0.svg";